import * as yup from "yup"
import { type StringSchema } from "yup"
import { dig } from "./util/misc"
import validations from "./util/validations"

declare module "yup" {
  export interface StringSchema {
    vat(countryField: string, defaultCountry?: string | null): StringSchema
    gln(countryField: string, defaultCountry?: string | null): StringSchema
    orgid(countryField: string, defaultCountry?: string | null): StringSchema
  }

  export interface TestContext<C = object> {
    from: Array<{ schema: Schema<any, C>; value: any }>
  }
}

yup.setLocale({
  mixed: {
    required: "misc.required_field",
  },
  string: {
    email: "customer.email_format",
  },
})

yup.addMethod<StringSchema>(yup.string, "vat", function (countryField: string, defaultCountry?: string | null) {
  return this.test({
    name: "vat",
    test: async function (vatId) {
      if (!vatId) {
        return true
      }

      const country = dig(this.from[this.from.length - 1].value, countryField) || defaultCountry

      if (validations.validateVat(vatId, country)) {
        return true
      }

      return this.createError({
        message: "address.vat_error",
        path: this.path,
      })
    },
    exclusive: false,
  })
})

yup.addMethod<StringSchema>(yup.string, "gln", function (countryField: string, defaultCountry?: string | null) {
  return this.test({
    name: "gln",
    test: async function (gln) {
      if (!gln) {
        return true
      }

      const country = dig(this.from[this.from.length - 1].value, countryField) || defaultCountry

      if (!country || !["SE", "DK", "NO", "FI"].includes(country)) {
        return true
      }

      if (validations.validateGlnNumber(gln, country)) {
        return true
      }

      return this.createError({
        message: "misc.invalid_gln_number",
        path: this.path,
      })
    },
    exclusive: false,
  })
})

yup.addMethod<StringSchema>(yup.string, "orgid", function (countryField: string, defaultCountry?: string | null) {
  return this.test({
    name: "orgid",
    test: async function (orgid) {
      if (!orgid) {
        return true
      }

      const country = dig(this.from[this.from.length - 1].value, countryField) || defaultCountry

      if (!country || !["SE", "DK", "NO", "FI"].includes(country)) {
        return true
      }

      if (validations.validateOrgID(orgid, country)) {
        return true
      }

      return this.createError({
        message: "misc.invalid_org_id",
        path: this.path,
      })
    },
    exclusive: false,
  })
})

export default yup
